import React from 'react';

import Alert from 'design-system/Alert';
import { push } from '@scale/frontend-lib/link';
// TODO: Use new button
// eslint-disable-next-line import-path/forbidden
import Button from 'design-system/ButtonLegacy';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import RemoAdminContext from 'react-scale/components/remoAdmin/remoAdminContext';

export default class CorpAliases extends React.Component<
  {
    objectId: string;
  },
  { aliases: string[]; alias: string; error: string }
> {
  state = {
    aliases: [],
    alias: '',
    error: '',
  };

  async componentDidMount() {
    try {
      const aliases = await apiFetch(null, `corp-api/lookup/${this.props.objectId}/aliases`);
      this.setState({ aliases });
    } catch (e) {
      /* no - op */
    }
  }

  handleAliasChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const alias = e.target.value;
    this.setState({
      alias,
    });
  };

  createAlias = async (isRemoAdmin: boolean) => {
    try {
      await apiFetch(null, `corp-api/lookup/alias/${this.state.alias}/${this.props.objectId}`, {
        method: 'PUT',
      });
      // omit redirect when using from remoadmin
      if (!isRemoAdmin) push(`/corp/lookup/${this.state.alias}`);
    } catch (err) {
      this.setState({ error: err.response.error || '' });
      defaultApiFetchErrorHandler(err);
    }
  };

  render() {
    return (
      <RemoAdminContext.Consumer>
        {({ isRemoAdmin }) => (
          <div>
            <ul>
              {this.state.aliases.map(alias => (
                <li key={alias}>{alias}</li>
              ))}
            </ul>
            <div className="alias-container">
              <div className="alias-search">
                <input
                  className="alias__input"
                  type="text"
                  value={this.state.alias}
                  onKeyUp={e => {
                    e.key === 'Enter' && this.createAlias(isRemoAdmin);
                  }}
                  onChange={this.handleAliasChange}
                />
              </div>

              <Button
                type="success"
                disabled={this.state.alias.length === 0}
                onClick={() => this.createAlias(isRemoAdmin)}
              >
                Create Alias
              </Button>

              {this.state.error && <Alert severity="error">{this.state.error}</Alert>}

              <style jsx>{`
                .alias-container {
                  margin-bottom: 12px;
                }

                .alias-search {
                  margin-bottom: 10px;
                }

                .alias__input {
                  width: 200px;
                  border-radius: var(--border-radius);
                  outline: 0;
                  padding: 10px;
                  border: 1px solid rgba(0, 0, 0, 0.1);
                }

                .alias__message {
                  margin-left: 12px;
                  margin-right: 12px;
                }
              `}</style>
            </div>
          </div>
        )}
      </RemoAdminContext.Consumer>
    );
  }
}
